import { createSlice } from '@reduxjs/toolkit';

const initialStaticState = {
  provinceList: [],
  countryList: [],
  processorCredentialList: [],
};

const staticSlice = createSlice({
  name: 'staticData',
  initialState: initialStaticState,
  reducers: {
    loadStaticData(state, action) {
      state.mcc = action.payload.mcc;
      state.provinceList = action.payload.provinceList;
      state.countryList = action.payload.countryList;
    },
    clearStaticData: () => initialStaticState,
    updateProvinceList(state, action) {
      state.provinceList = action.payload.result;
    },
    updateCountryList(state, action) {
      state.countryList = action.payload;
    },
    updateProcessorCredentialList(state, action) {
      state.processorCredentialList = action.payload.result.products;
    },
  },
});

export const {
  loadStaticData,
  clearStaticData,
  updateProvinceList,
  updateCountryList,
  updateProcessorCredentialList,
} = staticSlice.actions;
export default staticSlice.reducer;
